export default __webpack_public_path__ + "static/media/web_developer.450ab726.svg";